import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "details" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Player Details", -1)
const _hoisted_3 = {
  key: 0,
  class: "center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, "icon", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "name", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "uuid", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "discord_id", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "tag", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "nickanme", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "guild_id", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, "skin", -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", null, "created_at", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "cached_at", -1)
const _hoisted_17 = { key: 1 }

import { CacheService } from '@/services/cache.service';
import { DataModel } from '@/models/data.model';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import DateFormat from "@/components/DateFormat.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsView',
  setup(__props) {

const route = useRoute()
const uuid = route.params.uuid as string;
const player = ref<DataModel>()

CacheService.retrieveByUuid(uuid).then(rsp => {
  player.value = rsp.data
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (player.value)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("td", null, [
              _createElementVNode("img", {
                src: player.value.avatar,
                class: "avatar"
              }, null, 8, _hoisted_5),
              _createElementVNode("img", {
                src: `https://visage.surgeplay.com/face/32/${player.value.uuid}`,
                class: "avatar"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(player.value.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, _toDisplayString(player.value.uuid), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(player.value.discordId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(player.value.tag), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(player.value.nickname), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, _toDisplayString(player.value.guildId), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("td", null, [
              _createElementVNode("img", {
                src: `https://visage.surgeplay.com/bust/64/${player.value.uuid}`,
                class: "skin"
              }, null, 8, _hoisted_14)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createVNode(DateFormat, {
              date: player.value.createdAt
            }, null, 8, ["date"])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createVNode(DateFormat, {
              date: player.value.cachedAt
            }, null, 8, ["date"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_17, "No data found for player " + _toDisplayString(_unref(uuid)), 1))
  ]))
}
}

})